import { api } from './client';

import type { AiSkillKey } from '@/lib/aiSkillsAdmin';

/**
 * Сводка тумблеров ИИ для админки — `GET /admin/ielts/ai-skills/overview`
 * (speaking-service, docs/CONTRACTS/ai-skills.md §4). Только admin и director.
 *
 * Числа — «сколько увидят, если включить»: серверный тумблер в них не входит.
 */
export type AiSkillOverview = {
  skill: AiSkillKey;
  server_on: boolean;
  /** Увидят сразу: право на навык, курс разрешает, навык сдан в mock test. */
  now: number;
  /** Увидят после mock test: право на навык и на mock test, не сдан. */
  after_mock: number;
};

export type AiSkillsJournalEntry = {
  skill: string;
  /** null — ключа до этого не было. */
  old: boolean | null;
  new: boolean;
  at: string;
  by_name: string;
};

export type AiSkillsOverview = {
  skills: AiSkillOverview[];
  students: number;
  mock_windows: { assigned: number; open_now: number };
  /** ready — записи-части, которые ученик получит; approved — одобренные, в том числе не опубликованные. */
  listening: { ready: number; approved: number };
  applies_within_sec: number;
  journal: AiSkillsJournalEntry[];
};

export const aiSkillsAdminApi = {
  overview: () => api.get<AiSkillsOverview>('/admin/ielts/ai-skills/overview').then((r) => r.data),
};
